import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {CssBaseline, Typography, Stack, Card as MuiCard, styled, Box, TextField, Button } from '@mui/material';
import TextAreaWithButton from '../components/common/TextAreaWithButton';
import axios from 'axios'; // Import axios
import BankDetails from './Bank';
import PopUpAlert from '../components/common/PopUpAlert';
import { useSnackbar } from '../SnackbarProvider';
import { JsxEmit } from 'typescript';
// import styled from '@emotion/styled';
// import { useVerification } from '../VerificationContext';

const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  margin: 'auto',
  marginTop:"0px",
  [theme.breakpoints.up('sm')]: {
    maxWidth: '450px',
  },
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
}));

const SignInContainer = styled(Stack)(({ theme }) => ({
  // padding: 0,
  // marginTop: '0px',
  // marginBottom:'10px',
  '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    zIndex: -1,
    inset: 0,
    backgroundImage:
      'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
    backgroundRepeat: 'no-repeat',
    ...theme.applyStyles('dark', {
      backgroundImage:
        'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
    }),
  },
}));

const InputWrapper = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3), // Adjust this value as needed
  position: 'relative',
}));

interface OtpResponse {
  status: string;
  responseCode:number;
  data:{
    verificationStatus: boolean;
    
  }
}

interface AadharProps{
  mobileNumber:string;
  id:string;
  textDisabled:boolean;
  setCurrentStep:React.Dispatch<React.SetStateAction<number>>;
  panNameMatch:boolean;
  aadhar:string;
  setAadhar:React.Dispatch<React.SetStateAction<string>>;
  aadharNameMatch:boolean;
  setAadharNameMatch:React.Dispatch<React.SetStateAction<boolean>>;
  isAadharVerified:boolean;
  setIsAadharVerified:React.Dispatch<React.SetStateAction<boolean>>;

  bankAcc:string;
  ifsc:string;
  bankVerified:boolean;
  bankNameMatch:boolean;
  setBankAcc:React.Dispatch<React.SetStateAction<string>>;
  setIfsc:React.Dispatch<React.SetStateAction<string>>;
  setBankVerified:React.Dispatch<React.SetStateAction<boolean>>;
  setBankNameMatch:React.Dispatch<React.SetStateAction<boolean>>;
  aadharStatus:{
    id:string;
    status:boolean;
  },
  bankStatus:{
    id:string;
    status:boolean;
  }
}

export const Aadhar: React.FC<AadharProps> = ({mobileNumber,id,textDisabled,setCurrentStep, panNameMatch,aadharStatus,bankStatus,aadhar,setAadhar,aadharNameMatch,setAadharNameMatch,isAadharVerified,setIsAadharVerified,
  bankAcc,setBankAcc,ifsc,setIfsc,bankVerified,setBankVerified,bankNameMatch,setBankNameMatch
}) => {
  const [aadharError, setAadharError] = useState<boolean>(false); // Aadhar error state as boolean
  const [isOtpSent, setIsOtpSent] = useState<boolean>(false); // OTP sent state as boolean
  const [otp, setOtp] = useState<string>(''); // OTP input state as string
  const [otpError, setOtpError] = useState<boolean>(false); // OTP error state as boolean
  const [errorMessage,setErrorMessage] = useState<string>('');
  const [otpTimer, setOtpTimer] = useState<number>(0); // Timer state for resend, typed as number
  const[isLoading,setIsLoading] = useState<boolean>(false);
  const [warning,setWarning] = useState<boolean>(false);
  const {showSnackbar} = useSnackbar(); 

  const navigate = useNavigate(); // Initialize useNavigate hook

  const validateAadhar = (aadhar: string): boolean => {
    const isValidLength = aadhar.length === 12;
    const isAllDigits = /^\d+$/.test(aadhar);
    return isValidLength && isAllDigits;
  };
  
  function validateOtp(otp: string): boolean {
    // Define criteria: OTP should be 6 digits and numeric
    const otpRegex = /^\d{6}$/;
  
    // Test the OTP against the regex
    return otpRegex.test(otp);
  }

  interface UserDataResponse {
    responseCode: number;
    responseMessage: string;
    data:boolean;
  }

  useEffect(()=>{
    console.log("aadharNameMatch",aadharNameMatch);
    if(!aadharNameMatch){
      setAadharError(true);
      setWarning(true);
      setErrorMessage('Your details will be verified manually.');
    }
  },[aadharNameMatch])

  const handleAadharChange = (value: string): void => {
          setErrorMessage('');
          setAadharError(false);
          setAadhar(value);
  }

  // Simulate sending OTP using Axios
  const handleSendOtp = async (): Promise<void> => {
    if(!validateAadhar(aadhar)){
      setWarning(false);
      setAadharError(true);
      setErrorMessage('Invalid Aadhaar. Please enter a 12-digit number.');
    }
    else{
      setIsLoading(true);
      setErrorMessage('');
      setAadharError(false);
      setOtpTimer(30);
        try {
          const a = true;
          // Make an API call to send OTP
          const token = localStorage.getItem('authToken');
          const headers = {
            Authorization: `Bearer ${token}`,
          };
          const phone = localStorage.getItem('mobile');
          const id = localStorage.getItem('id');
          const response = await axios.post<UserDataResponse>('https://promoter-api.benow.in/api/kyc/v1/auth/register', { merchantId:id, mobileNumber:phone ,identityNumber:aadhar,actionType:"1" },
                { headers}
              );
            setIsLoading(false);
            if(response.data.responseCode===200){
              setIsOtpSent(true);
               // Reset timer to 10 seconds
              showSnackbar("OTP Sent Successfully",'success');
            }
            else if(response.data.responseMessage==="Invalid Document Details!"){
              showSnackbar('Invalid Aadhar Card','error');
              setWarning(false);
              setIsAadharVerified(false);
              setIsLoading(false);
              setOtpTimer(0);
              setAadharError(true);
              setErrorMessage('Invalid Aadhar Card.')
            }
            else{
              showSnackbar('Server Error.','warning');
              setWarning(true);
              setAadharError(true);
              setErrorMessage('Internal Server Error.  Your details will be verified manually.')
              setIsAadharVerified(true);
              setCurrentStep(2);
            }
          } catch (error:any) {
            console.log(error)
            if(error.response.data?.responseCode===400 && error.response.data?.responseMessage==="Invalid Document Details!"){
              showSnackbar('Invalid Aadhar Card','error');
              setWarning(false);
              setIsAadharVerified(false);
              setIsLoading(false);
              setOtpTimer(0);
              setAadharError(true);
              setErrorMessage('Invalid Aadhar Card.')
            } 
            else{
              showSnackbar('Unexpected Error Occurred','error');
              setWarning(true);
              setOtpTimer(0);
              setIsAadharVerified(false);
              setAadharError(true);
              setErrorMessage('Unexpected Error Occurred.')
            }
        }
      
    }
  };

  // Verify OTP using Axios
  const handleVerify = async (): Promise<void> => {
    if(!validateOtp(otp)){
      setWarning(false);
      setErrorMessage("Please enter valid 6-digit OTP");
      setOtpError(true);
    }
    else {
      try {
        console.log(isAadharVerified)
        setIsLoading(true);
        setOtpError(false);
        const token = localStorage.getItem('authToken');
        const headers = {
          Authorization: `Bearer ${token}`,
        };
        const phone = localStorage.getItem('mobile');
        const id = localStorage.getItem('id');
        // Make an API call to verify the OTP
        const response = await axios.post<OtpResponse>('https://promoter-api.benow.in/api/kyc/v1/auth/verifyAadharOtp', { mobileNumber:phone, otp:otp,merchantId:id, aadharNumber:aadhar },{headers});
        
        console.log("inside try repsonse");
        if (response.status === 200  && response.data?.data?.verificationStatus === true) {
       
          // console.log('Aadhar verified with OTP:', otp);
          // alert('Aadhar verified successfully!');
          setIsAadharVerified(true);
          setCurrentStep(2);
          setOtpTimer(0);
          setAadharNameMatch(true);
          showSnackbar('Aadhar verified successfully','success');
          // navigate('/pan-details')// Navigate to Pan component after successful verification
        } else if(response.status === 200 && response.data?.data?.verificationStatus===false){
          // alert('OTP verification failed. Please try again.');
          setIsAadharVerified(true);
          setCurrentStep(2);
          setAadharNameMatch(false);
          showSnackbar('Name Mismatch!','warning');
          setWarning(true);
          setOtpTimer(0);
          setAadharError(true);
          setErrorMessage('Your details will be verified manually.')
        }
        else if(response.data?.responseCode===422){
          // console.log("inside manually verify");
          showSnackbar("Invalid OTP.",'error');
          setIsAadharVerified(false);
          // setAadharNameMatch(false);
          setCurrentStep(1);
          setOtpTimer(0);
          setIsLoading(false);
          setWarning(false);
          setOtpError(true);
          setErrorMessage('Invalid OTP.');
        }
        else {
          showSnackbar("Server Error.",'warning');
          setIsAadharVerified(true);
          setAadharNameMatch(false);
          setCurrentStep(2);
          setOtpTimer(0);
          setIsLoading(false);
          setWarning(true);
          setAadharError(true);
          setErrorMessage('Server Error! Your details will be verified manually.');
        }
      } catch (error:any) {
        console.error('Error verifying OTP:', error);
        console.log('inside catch blocak');
        if(error.data?.responseCode===400 && error.responseMessage==='Invalid Document Details!'){
          // console.log("inside manually verify");
          showSnackbar("Invalid Aadhar Card.",'error');
          setIsAadharVerified(false);
          // setAadharNameMatch(false);
          setCurrentStep(1);
          setOtpTimer(0);
          setIsLoading(false);
          setWarning(false);
          setOtpError(true);
          setErrorMessage('Invalid Aadhar Card');
        }
        else if(error.data?.responseCode===422){
          // console.log("inside manually verify");
          showSnackbar("Invalid OTP.",'error');
          setIsAadharVerified(false);
          // setAadharNameMatch(false);
          setCurrentStep(1);
          setOtpTimer(0);
          setIsLoading(false);
          setWarning(false);
          setOtpError(true);
          setErrorMessage('Invalid OTP.');
        }
        else{
          showSnackbar("Unexpected Error Occurred",'error');
          setIsAadharVerified(false);
          // setAadharNameMatch(false);
          setCurrentStep(1);
          setOtpTimer(0);
          setIsLoading(false);
          setWarning(false);
          setOtpError(true);
          setErrorMessage('Unexpected Error Occurred');
        }
      }
    }
  };

 
  // Timer for Resend OTP functionality
  useEffect(() => {
    let timerId: NodeJS.Timeout | null = null;
    if (isOtpSent && otpTimer > 0) {
      timerId = setInterval(() => {
        setOtpTimer((prevTimer) => prevTimer - 1);
      }, 1000); // Decrease every second
    }

    return () => {
        if (timerId) clearInterval(timerId); // Clean up interval on component unmount
    };
  }, [otpTimer, isOtpSent]);

  return (
    // <Container maxWidth="sm">
    <SignInContainer direction="column" justifyContent="space-between">
      <CssBaseline enableColorScheme />
          <InputWrapper>
            <TextAreaWithButton
              errorMessage={errorMessage}
              label="Aadhar Number"
              inputValue={aadhar}
              onChange={handleAadharChange}
              onClick={handleSendOtp}
              buttonText={!isOtpSent ? 'Send OTP' : (isLoading ? 'Loading...' : (otpTimer ? `Resend in ${otpTimer} sec` : 'Resend'))}
              ariaLabel="phone"
              disabled={ (otpTimer > 0) || isAadharVerified || textDisabled || isLoading}
              prefilled={false ||textDisabled || isAadharVerified}
              verified = {isAadharVerified}
              timer = {otpTimer}
            />
            {errorMessage && aadharError &&(
        <Typography 
          color={warning ? 'orange' : 'error'} 
          fontSize="10px" 
          position="absolute" 
          bottom="-30px"
        >
          {errorMessage}
          </Typography>)
          }
          </InputWrapper>
          <InputWrapper>
            {isOtpSent && (!isAadharVerified) &&(
              <TextAreaWithButton
              errorMessage={errorMessage}
              label=" OTP"
              inputValue={otp}
              onChange={setOtp}
              onClick={handleVerify}
              buttonText="Verify OTP"
              ariaLabel="otp"
              disabled={isLoading}
              verified={isAadharVerified}
              />
            )}
            {otpError && errorMessage && (<>
              <Typography 
          color={warning ? 'orange' : 'error'} 
          fontSize="10px" 
          position="absolute" 
          bottom="-15px"
        >
          {errorMessage}
          </Typography><InputWrapper></InputWrapper>
          </>)            
          }
          </InputWrapper>
        <BankDetails mobileNumber={mobileNumber} id={id} textDisabled={!isAadharVerified} panNameMatch={panNameMatch} aadharNameMatch={aadharNameMatch}
         bankAcc={bankAcc}
         setBankAcc={setBankAcc}
         ifsc={ifsc}
         setIfsc={setIfsc}
         bankNameMatch={bankNameMatch}
         setBankNameMatch={setBankNameMatch}
         bankVerified={bankVerified}
         setBankVerified={setBankVerified}
         setCurrentStep={setCurrentStep}
         />
        </SignInContainer>
    );
};

export default Aadhar;
